import { render, staticRenderFns } from "./UsergroupsAdd.vue?vue&type=template&id=844fb694&scoped=true"
import script from "./UsergroupsAdd.vue?vue&type=script&lang=js"
export * from "./UsergroupsAdd.vue?vue&type=script&lang=js"
import style0 from "./UsergroupsAdd.vue?vue&type=style&index=0&id=844fb694&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844fb694",
  null
  
)

export default component.exports